import Form from "./form";

export default {
  Form
};
